import _objectSpread from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\xams.UI.Web.Player\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
// npm
import checkTypes from 'check-types';

// function predicates
import { generator } from './methods/function/generator';

// array predicates
import { arrayLike } from './methods/array/array-like';
var check = _objectSpread({}, checkTypes, {
  arrayLike: arrayLike,
  generator: generator
});
export { check };